import { render, staticRenderFns } from "./wuhai.vue?vue&type=template&id=505d5de5&scoped=true&"
import script from "./wuhai.vue?vue&type=script&lang=js&"
export * from "./wuhai.vue?vue&type=script&lang=js&"
import style0 from "./wuhai.vue?vue&type=style&index=0&id=505d5de5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505d5de5",
  null
  
)

export default component.exports